import { useEffect, useState } from "react";

import debounce from "lodash.debounce";

import { Button, Search } from "@vimeo/iris/components";

import { Folders } from "./Folders";
import { FolderMetadata } from "vimeo";
import { sendAnalyticsEvent, EventName } from "../analytics/common";

interface Props {
    onFolderSelected: (
        uri: string,
        metadata?: FolderMetadata,
        rootFolder?: boolean
    ) => void;
    onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    numRootFolderVideos: number;
}

export function VideosToolbar(props: Props) {
    const [numVideos, setNumVideos] = useState(0);
    const { numRootFolderVideos } = props;

    useEffect(() => {
        setNumVideos(numRootFolderVideos);
    }, [numRootFolderVideos]);

    return (
        <div className="slds-grid slds-grid_align-spread">
            <div className="slds-col">
                <div
                    className="slds-var-m-bottom_medium"
                    style={{ display: "flex", flexFlow: "row nowrap" }}
                >
                    <Folders
                        folderSelected={(uri, folderMetadata, rootFolder) => {
                            if (!rootFolder) {
                                setNumVideos(
                                    folderMetadata?.connections.videos.total ||
                                        0
                                );
                            }
                            props.onFolderSelected(
                                uri,
                                folderMetadata,
                                rootFolder
                            );
                        }}
                    />
                    <span
                        className="slds-var-m-left_small slds-var-m-top_small"
                        style={{
                            color: "#9D9D9D",
                        }}
                    >
                        {numVideos} items
                    </span>
                </div>
            </div>
            <div className="slds-col">
                <div style={{ display: "flex", flexFlow: "row nowrap" }}>
                    <div className="slds-form-element__control slds-var-m-right_small">
                        <Button
                            element="a"
                            href="https://vimeo.com/analytics"
                            onClick={() => {
                                sendAnalyticsEvent(EventName.openAnalytics, {
                                    actor_resource_role: null, //constant
                                    actor_team_role: null, //constant
                                    entry_page: null, //constant
                                    is_preset_applied: null, //constant
                                    page: null, //constant
                                    path: null, //constant
                                    team_owner_id: null, //constant
                                    team_size: null, //constant
                                    team_subscription_type: null, //constant
                                    upload_id: null, //constant
                                    video_app_id: null, //constant
                                    video_status: null, //constant
                                    video_type: null, //constant
                                    video_id: null, //constant
                                    video_privacy: null, //constant
                                    video_embed_privacy: null, //constant
                                    is_video_password_protected: null, //constant


                                    location: "app_home",
                                    // cta: "analytics_dashboard", TODO: add this field to schema if required
                                }, 2);
                            }}
                            target="_blank"
                            format="secondary"
                        >
                            Analytics dashboard
                        </Button>
                    </div>
                    <div className="slds-form-element__control slds-var-m-right_small">
                        <Button
                            element="a"
                            href="https://vimeo.com/upload/videos"
                            onClick={() => {
                                sendAnalyticsEvent(EventName.click, {
                                    click_type: "click", //constant
                                    device_type: null, //constant
                                    feature: "upload", //constant
                                    location: "app_home", //constant
                                    name: "upload_video", //constant
                                    page: "strategic_integration", //constant
                                    path: null, //constant
                                    target: "upload_page", //constant
                                    target_path: "/upload/videos", //constant
                                    type: "general", //constant
                                    // cta: "upload", TODO: add this field to schema if required
                                    copy: null
                                }, 151, true);
                            }}
                            target="_blank"
                            format="primary"
                        >
                            Upload video
                        </Button>
                    </div>
                    <div className="slds-form-element__control">
                        <Search
                            id="videoSearchInput"
                            placeholder="Search"
                            onChange={
                                debounce(props.onSearchChange, 250) as any
                            }
                            variant="minimal"
                            format="alternative"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
